var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 94,
  height: 93,
  fill: "none",
  viewBox: "0 0 94 93",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#0F8491",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.892,
  d: "M85.53 42.729v3.547A38.563 38.563 0 1 1 62.66 11.03m22.869 4.397L46.966 54.027l-11.57-11.57"
})));
export { SvgCheckCircle as ReactComponent };
export default __webpack_public_path__ + "assets/images/check-circle.svg";